export default __webpack_public_path__ + "cb0aff6202ef704d50b9aac4ec82009e.svg";